import {Injectable} from '@angular/core';
import {AbstractDataServiceDtoAdapter} from 'src/app/modules/core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {PaymentRequestDataService} from './PaymentRequestData.service';
import {PaymentRequestConverter} from '../../../api/entity/converter/paymentRequest.converter';
import {PaymentRequestModel} from '../../../api/entity/paymentRequest.model';


@Injectable({providedIn: 'root'})
export class PaymentRequestDataServiceAdapter extends
    AbstractDataServiceDtoAdapter<PaymentRequestModel, PaymentRequestConverter> {
    constructor(dataService: PaymentRequestDataService, converter: PaymentRequestConverter) {
        super(dataService, converter);
    }
    newStoredEntityInstance(): PaymentRequestModel {
        return new PaymentRequestModel();
    }
}
